"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _iconsArrowLeft = require("../../resources/icons-arrow-left.svg");
var _Button = _interopRequireDefault(require("../buttons/Button"));
var _Heading = _interopRequireDefault(require("../text/Heading"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Paper = exports["default"] = /*#__PURE__*/function (_Component) {
  function Paper() {
    _classCallCheck(this, Paper);
    return _callSuper(this, Paper, arguments);
  }
  _inherits(Paper, _Component);
  return _createClass(Paper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        sx = _this$props.sx,
        className = _this$props.className,
        padding = _this$props.padding,
        theme = _this$props.theme,
        title = _this$props.title,
        floatingTitle = _this$props.floatingTitle,
        titleSize = _this$props.titleSize,
        borderColor = _this$props.borderColor,
        borderWidth = _this$props.borderWidth,
        actionLink = _this$props.actionLink,
        actionLinkText = _this$props.actionLinkText,
        children = _this$props.children,
        backButton = _this$props.backButton,
        onBack = _this$props.onBack,
        borderFromBreakpoint = _this$props.borderFromBreakpoint,
        overflow = _this$props.overflow,
        titleFontSize = _this$props.titleFontSize,
        titleFontWeight = _this$props.titleFontWeight,
        titleSx = _this$props.titleSx;
      var style = {
        overflow: overflow,
        borderColor: borderColor
      };
      if (theme && borderFromBreakpoint) {
        style[theme.breakpoints.down(borderFromBreakpoint)] = {
          borderWidth: "0px",
          borderRadius: "0"
        };
        style[theme.breakpoints.up(borderFromBreakpoint)] = {
          borderWidth: "1px",
          borderRadius: "16px!important"
        };
      } else {
        style.borderWidth = borderWidth ? borderWidth + "px" : "1px";
        style.borderRadius = "16px";
      }
      return /*#__PURE__*/_react["default"].createElement(_material.Paper, {
        className: "klayo-paper " + className,
        sx: _objectSpread(_objectSpread({}, style), {}, {
          padding: padding
        }, sx)
      }, title && /*#__PURE__*/_react["default"].createElement(_material.Stack, {
        direction: "row",
        justifyContent: "space-between"
      }, /*#__PURE__*/_react["default"].createElement("div", null, backButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "simple",
        size: "sm",
        onClick: function onClick(e) {
          return onBack(e, "back");
        },
        startIcon: /*#__PURE__*/_react["default"].createElement(_iconsArrowLeft.ReactComponent, null),
        label: "Back"
      }), /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
        className: "klayo-paper_title",
        size: titleSize,
        text: title,
        sx: _objectSpread({
          fontSize: titleFontSize,
          fontWeight: titleFontWeight,
          margin: floatingTitle ? "10px" : "0 0 24px 0",
          position: floatingTitle ? "absolute" : null,
          borderRadius: floatingTitle ? "5px" : null,
          background: floatingTitle ? "white" : null,
          zIndex: floatingTitle ? "9" : null,
          padding: floatingTitle ? "10px" : null
        }, titleSx)
      })), actionLink && actionLinkText && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: actionLink
      }, actionLinkText)), children);
    }
  }]);
}(_react.Component);
_defineProperty(Paper, "defaultProps", {
  padding: {
    xs: "24px",
    md: "24px 31px 24px 31px"
  },
  title: null,
  titleFontWeight: 600,
  floatingTitle: false,
  overflow: "hidden",
  titleFontSize: {
    xs: "18px",
    sm: "18px",
    md: "20px"
  },
  borderColor: "var(--neon-blue-nb-050)"
});